/* tslint:disable */
/* eslint-disable */
/**
 * classes-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PriceOverrideStatus = {
    Approved: 'Approved',
    Rejected: 'Rejected',
    Reverted: 'Reverted',
    NeedsReview: 'Needs Review',
    Canceled: 'Canceled'
} as const;

export type PriceOverrideStatus = typeof PriceOverrideStatus[keyof typeof PriceOverrideStatus];



